<template>
  <div id="myaccount">
    <mt-header title="账户安全">
      <mt-button @click="goback" slot="left" icon="back">返回</mt-button>
    </mt-header>

    <div class="myaccount">
      <div class="ace" @click="gotoEditPassword">
        <div class="acountdesc">修改登录密码</div>
        <img src="/static/img/user/center/rightArrow.png" />
      </div>

      <div v-if="approveStatus == '1' || approveStatus == '7'">
        <div class="ace" @click="gotoEditSigncord">
          <div class="acountdesc">{{signPasswordTitle}}</div>
          <img src="/static/img/user/center/rightArrow.png" />
        </div>
      </div>
      <div class="ace" @click="gotoEditBindPhone">
        <div class="acountdesc">{{ phoneName }}</div>
        <img src="/static/img/user/center/rightArrow.png" />
      </div>
      <!-- <div v-show="!editOrBindEmail" class="ace">
        <div class="acountdesc">已绑定</div>
      </div> -->
      <div class="ace" @click="gotoEditBindMail">
        <div class="acountdesc">{{ mailName }}</div>
        <img src="/static/img/user/center/rightArrow.png" />
      </div>
      <!-- <div v-show="!editOrBindEmail" class="ace">
        <div class="acountdesc">已绑定</div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { Toast } from "mint-ui";
import { getCookie } from '@/js/utils.js'
export default {
  data() {
    return {
      approveStatus: "",
      loginNameOrApprovalStatus: "",
      status: 0,
      mobile: "",
      photoId: 0,
      _selected: "",
      mailStatus: "",
      mailName: "绑定邮箱",
      phoneName: "绑定手机号",
      mailPath: "",
      mailParams: {},
      mail: "",
      routeNameMail: "",
      editOrBindEmail: true,
      signPasswordTitle: '',
      access_token: ''
    };
  },
  methods: {
    goback: function() {
      history.go(-1); //后退1页
    },
    gotoEditPassword: function() {
      var redirectUrl = window.location.href;
      window.location.href=process.env.USER_ACCOUNT+'/userCenter/security?access_token=' + this.access_token + '&redirectUrl='+redirectUrl
      // this.$router.push({
      //   path: "/my/editpass",
      //   name: "editpass"
      // });
    },
    gotoEditSigncord: function() {
      this.$router.push({
        path: "/my/editSignCode",
        name: "editSignCode",
        query: {
          title: encodeURIComponent(this.signPasswordTitle)
        }
      });
    },
    gotoEditBindPhone: function() {
        var redirectUrl = window.location.href;
        window.location.href=process.env.USER_ACCOUNT+'/userCenter/associationChange?clientId=925220&type=phone' + '&access_token=' + this.access_token + '&redirectUrl='+redirectUrl
    },
    gotoEditBindMail: function() {
        var redirectUrl = window.location.href;
        window.location.href=process.env.USER_ACCOUNT+'/userCenter/associationMail?clientId=925220&type=email' + '&access_token=' + this.access_token + '&redirectUrl='+redirectUrl
    //   if(this.mailName =="修改邮箱"){
    //     this.$toast('此功能暂未开放');
    //     return false;
    //   }
    //   this.$router.push({
    //     path: this.mailPath,
    //     name: this.routeNameMail,
    //     params: {
    //       mail: this.mail
    //     }
    //   });
    },
    initParams() {
      let query = this.$route.query;
      this._selected = query._selected;
      var _mainIndex_Url = domain("_mainIndex"); //个人中心数据
      this.$http
        .post(_mainIndex_Url, { emulateJSON: true })
        .then(
          function(response) {
            console.log(response);
            var returnDate = response.data.data;
            this.approveStatus = returnDate.approveStatus;
            this.signPasswordTitle = returnDate.setSignPassword === 'YES' ? '修改签约密码' : '设置签约密码' // YES 设置过 NO 没设置过
            var email = returnDate.email;
            var phone=returnDate.phone;
            var registerType = returnDate.registerType;
            if (email == null || email == "" || typeof email == "undefined") {
              this.mailName = "绑定邮箱";
            }else{
              this.mailName = "换绑邮箱";
            }
            if (phone == null || phone == "" || typeof phone == "undefined") {
              this.phoneName = "绑定手机号";
            }else{
              this.phoneName = "换绑手机号";
            }

            // if (email == null || email == "" || typeof email == "undefined") {
            //   this.mailName = "绑定邮箱";
            //   this.mailPath = "/my/bindemail";
            //   this.routeNameMail = "bindemail";
            // } else if (
            //   email != null &&
            //   email != "" &&
            //   typeof email != "undefined" &&
            //   registerType == 2
            // ) {
            //   this.editOrBindEmail = false;
            // } else if (
            //   email != null &&
            //   email != "" &&
            //   typeof email != "undefined"
            // ) {
            //   this.mailName = "换绑邮箱";
            //   this.mailPath = "/my/editemail";
            //   this.mail = email;
            //   this.routeNameMail = "editemail";
            // }
          },
          function(error) {
            console.log(error);
            //Toast("数据获取响应异常.")
          }
        )
        .catch(function(response) {
          console.log(response);
          //Toast("数据获取响应异常.")
        });
    }
  },
  components: {},
  mounted: function() {
    this.access_token = getCookie('access_token')
    this.initParams();
  }
};
</script>
<style>
#myaccount {
  background-color: #ececec;
}

.myaccount {
  margin-top: 5%;
  background-color: #ffffff;
  color: #7d7d7d;
  font-size: 0.8rem;
}

.ace {
  height: 50px;
  width: 90%;
  margin: 0 auto;
  border-bottom: 1px dashed #d4d4d4;
  line-height: 50px;
}

.ace img {
  float: right;
  margin-top: 24px;
  width: 7px;
}
.acountdesc {
  display: inline-block;
  font-size: 0.9rem;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/module/my/MyAccount.vue